import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MatchService } from '../../_core/services/match.service';
import { Match } from '../../_shared/models/match.model';
import { Subject } from 'rxjs';
import { finalize, map, takeUntil, tap } from 'rxjs/operators';
import { IonRefresher } from '@ionic/angular';

@Component({
  standalone: false,
    selector: 'app-match-list',
    templateUrl: './match-list.component.html',
    styleUrls: ['./match-list.component.scss'],
})
export class MatchListComponent implements OnInit, OnDestroy {
    @Input() playerId: string;

    matches: Match[] = [];
    isLoading = false;
    getMoreMatches = false;
    page = 0;
    private destroyed$: Subject<void> = new Subject();

    constructor(
        private matchService: MatchService,
    ) { }

    ngOnInit() {
        this.getMatches();
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    doRefresh(refresher: IonRefresher) {
        this.page = 0;
        this.matches = [];
        this.getMatches(refresher);
    }

    doInfinite(infiniteScroll) {
        this.page++;
        this.getMatches();
        setTimeout(() => {
            infiniteScroll.target.complete();
        }, 1500);
    }

    getMatches(refresher?) {
        this.isLoading = true;

        const paginationConfig = {
            page: this.page,
            sort: -1,
            limit: 7,
            type: 'my-player'
        };

        this.matchService.getOwnersMatches(paginationConfig, this.playerId)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                    if (refresher) {
                        refresher.detail.complete();
                    }
                }),
                map(res => res.data),
                tap((matches) => {
                    this.getMoreMatches = matches.length < 7
                        ? false
                        : true
                }),
                takeUntil(this.destroyed$)
            )

            .subscribe(
                moreMatches => {
                    this.matches = [...this.matches, ... moreMatches]
                }
            );
    }

}
